<template>
  <span></span>
</template>

<script>
export default {
  name: "inject-tag",
  props: {
    content: {
      type: String,
      default: ""
    },
    tagType:{
      default:"div"
    },
    appendTo:String
  },
  mounted () {
    if(this.tagType==='script'){
      const script = document.createElement("script");
      script.textContent = this.content.trim();
      return document.head.appendChild(script);
    }
    const tag = document.createElement(this.tagType);
    tag.innerHTML = this.content.trim();

    document.querySelector(`[data-field-id="${this.appendTo}"]`).append(tag.firstChild);
    // document.body.append(tag.firstChild);
    // ch2fio
  }
};
</script>
